var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "z-accordion-item",
      class: { "z-accordion-item--opened": _vm.state },
    },
    [
      _c(
        "a",
        {
          staticClass: "z-accordion-item__header",
          attrs: { href: "#" + _vm.itemId },
          on: {
            click: function ($event) {
              return _vm.toggleItem($event)
            },
          },
        },
        [
          _c(
            "span",
            { staticClass: "z-accordion-item__header-button" },
            [
              _vm._t("icon", function () {
                return [
                  _c("z-icon", {
                    attrs: {
                      name: _vm.iconName,
                      dir: "left",
                      width: "20",
                      height: "20",
                    },
                  }),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("header"),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        { on: { enter: _vm.animationEnter, leave: _vm.animationLeave } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state,
                  expression: "state",
                },
              ],
              staticClass: "z-accordion-item__body",
            },
            [_vm._t("body")],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }